
import "../css/resume.css";
import { HiDownload } from "react-icons/hi";
import data from "../data/data";

const Resume = () => {
    return (
        <section className="app__resume">
            <div className="app__resume-container d-flex flex-item-center">
                <div className="app__resume-header">
                    <h2> My Resume </h2>
                </div>

                <div className="app__resume-body">
                    <div className="app__resume-body_fields">
                        <div className="app__resume-body_field -details">
                            <h2> Anyigor Emmanuel </h2>
                            <p className="-address"> Yaba Lagos, Nigeria </p>
                            <div className="-contact_info d-flex gap-0 flex-item-center">
                                <p className="-info"> +234 7061326122 </p>
                                <a href="https://github.com/EA10-lite" target="_blank" rel='noreferrer'>
                                    <span> Github </span>
                                </a>
                                <a href="mailto:emanuelanyigor@gmail.com" target="_blank" rel='noreferrer'>
                                    <span> emanuelanyigor@gmail.com </span>
                                </a>
                            </div>
                        </div>

                        <div className="app__resume-body_field -education">
                            <div className="app__resume-field_header">
                                <h3> Education and Qualification </h3>
                            </div>
                            <div className="app__resume-field_body">
                                <div className="app__resume-field_row d-flex flex-item-between">
                                    <div className="-left">
                                        <h4> The Federal University of Lagos </h4>
                                        <p> B.Sc in Systems Engineering </p>
                                    </div>
                                    <div className="-date">
                                        <h4> Lagos, Nigeria </h4>
                                        <p> Expected 2024 </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="app__resume-body_field -skills">
                            <div className="app__resume-field_header">
                                <h3> Skills and Interests </h3>
                            </div>
                            <div className="app__resume-field_content">
                                <div className="-skills_field">
                                    <p className="-topic"> Technical Skills: </p>
                                    <div className="-skill_content">
                                        <p> <span> Proficiency: </span> HTML, CSS, Javascript, ReactJS, NextJS, NodeJS, Python, Git </p>
                                    </div>
                                    <div className="-skill_content">
                                        <p> <span> Exposure: </span> Typescript, Java, Firebase, Tailwind, SASS </p>
                                    </div>
                                </div>
                                <div className="-skills_field">
                                    <div className="-skill">
                                        <p> <span> Soft Skills: </span> Communication, Team Work, Leadership, Problem Solving, Attention To Details etc.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="app__resume-body_field -experience">
                            <div className="app__resume-field_header">
                                <h3> Work Experience </h3>
                            </div>
                            <div className="app__resume-field_content">
                                { data.experience.map(experience => (
                                    <div key={experience.id} className="-experience">
                                        <div className="-experience_header d-flex flex-item-between">
                                            <div className="">
                                                <h4> { experience.company }  </h4>
                                                <h5> { experience.title } </h5>
                                            </div>
                                            <div className="-experience_date_box">
                                                <p> { experience.start_date } - { experience.end_date } </p>
                                            </div>
                                        </div>
                                        <ul className="-experience_body">
                                            { experience.roles.map((role,index) => (
                                                <li key={index} className="-experience_role">
                                                    {/* <div className="-experince_dot" /> */}
                                                    <p> { role } </p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="app__resume-body_field -developement"></div>
                    </div>
                </div>

                <div className="app__resume-footer">
                    <a href="/" className="d-flex flex-item-center gap-1">
                        <span> Download Resume </span>
                        <HiDownload />
                    </a>
                </div>
            </div>
        </section>
    )
}

export default Resume;